import { Avatar, Image, Space } from "antd";
import type { ReactNode } from "react";

type Props = {
  title?: ReactNode;
  imageUrl?: string;
  avatarIcon?: string;
  size?: number;
};

export const GenericLabel = ({ title, imageUrl, avatarIcon, size = 32 }: Props) => {
  if (!title) {
    return;
  }

  return (
    <Space>
      {imageUrl ? (
        <Image className="m-0" preview={false} src={imageUrl} width={size} height={size} />
      ) : (
        <Avatar shape="square" size={size} icon={<i className={`fa-solid ${avatarIcon}`} />} />
      )}
      {title}
    </Space>
  );
};
